import classNames from "classnames";

interface Props {
  label: string;
  type: "button" | "submit";
  onClick?: () => void;
  className?: string;
}

const Button = ({ label, type, onClick, className }: Props) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        "rounded-md px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300",
        className
      )}
    >
      {label}
    </button>
  );
};

export default Button;
